'use client';

import { useSyncExternalStore } from 'react';
import { useT } from '@/i18n/client';
import { flushQueue, getSyncState, subscribeSyncState } from '@/lib/offline';

const SERVER_SNAPSHOT = { online: true, pending: 0, syncing: false, lastError: null };

/**
 * Sync status, always honest: offline / N changes waiting / syncing / synced.
 * Hidden entirely when online with nothing pending. Click retries the flush.
 */
export function SyncStatusPill() {
  const t = useT();
  const state = useSyncExternalStore(subscribeSyncState, getSyncState, () => SERVER_SNAPSHOT);

  if (state.online && state.pending === 0 && !state.syncing) return null;

  const label = !state.online
    ? state.pending > 0
      ? t(state.pending === 1 ? 'sync.pendingOne' : 'sync.pendingMany', { count: state.pending })
      : t('sync.offline')
    : state.syncing
      ? t('sync.syncing')
      : t(state.pending === 1 ? 'sync.pendingOne' : 'sync.pendingMany', { count: state.pending });

  return (
    <button
      type="button"
      className={`vn-sync${state.online ? ' vn-sync--pending' : ' vn-sync--offline'}`}
      onClick={() => void flushQueue()}
      title={state.lastError ?? undefined}
    >
      <span className="vn-sync__dot" aria-hidden="true" />
      {label}
    </button>
  );
}
